<app-header />

<div class="reports-container">
  <!-- Título com ícone e textos (NOVO) -->
  <div class="reports-header">
    <div class="title-section">
      <img src="assets/icons/titleLogoReports.svg" alt="Reports" class="title-icon" />
      <span class="title-reports">Desempenho</span>
    </div>
  </div>

  <!-- Grid de Cards (sempre visível) -->
  <div class="reports-grid">
    @for (card of reportsCards; track $index) {
      <ng-container>
        <!-- Card com máscara -->
        @if (card.hasMask) {
          <app-collapsible-card-mask [hasMask]="card.hasMask" [isCollapsed]="areCardsCollapsed">
            <app-reports-card
              [borderColor]="card.borderColor"
              [title]="card.title"
              [content]="card.content"
              [cardId]="card.id"
              [isCollapsed]="areCardsCollapsed"
              [trackingConfig]="getTrackingConfig(card)"
              (seeMoreClicked)="onSeeMoreClick($event)"
            >
            </app-reports-card>
          </app-collapsible-card-mask>
        }

        <!-- Card sem máscara -->
        @if (!card.hasMask) {
          <app-reports-card
            [borderColor]="card.borderColor"
            [title]="card.title"
            [content]="card.content"
            [cardId]="card.id"
            [isCollapsed]="areCardsCollapsed"
            [trackingConfig]="getTrackingConfig(card)"
            (seeMoreClicked)="onSeeMoreClick($event)"
          >
          </app-reports-card>
        }
      </ng-container>
    }
  </div>

  <!-- Título do componente selecionado (apenas quando em sub-rota) -->
  @if (showComponentHeader()) {
    <div class="component-section">
      <div class="component-title-with-close">
        <h2 class="component-title" [style.color]="getSelectedCardColor()">
          {{ getComponentTitle() }}
        </h2>
        <button
          mat-icon-button
          class="close-button"
          [style.color]="getSelectedCardColor()"
          (click)="onCloseClick()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-divider
        class="component-divider"
        [style.border-color]="getSelectedCardColor()"
      ></mat-divider>
    </div>
  }

  <!-- Router outlet para as páginas filhas -->
  <router-outlet />
</div>

<app-chatbot-bubble />
